import { formatBrl } from "@/lib/rota";

type Props = {
  fuelBrl: number;
  tollBrl: number;
  /** "onPrimary" remove o cartão e adapta as cores para o fundo verde. */
  tone?: "default" | "onPrimary";
};

/**
 * Gráfico de composição do custo (combustível x pedágio).
 * SVG puro, sem bibliotecas — custo zero no bundle inicial e no PageSpeed.
 */
export function CostChart({ fuelBrl, tollBrl, tone = "default" }: Props) {
  const total = fuelBrl + tollBrl;
  if (total <= 0) return null;

  const onPrimary = tone === "onPrimary";
  const fuelPct = (fuelBrl / total) * 100;
  const tollPct = 100 - fuelPct;

  const rows = [
    { label: "Combustível", value: fuelBrl, pct: fuelPct, className: onPrimary ? "bg-primary-foreground" : "bg-primary" },
    { label: "Pedágio (estimativa)", value: tollBrl, pct: tollPct, className: "bg-accent" },
  ];

  return (
    <div
      className={
        onPrimary
          ? "mt-4 border-t border-primary-foreground/20 pt-3"
          : "rounded-2xl border border-border bg-card p-4 shadow-sm"
      }
    >
      <p
        className={`text-xs font-semibold uppercase tracking-widest ${
          onPrimary ? "opacity-80" : "text-muted-foreground"
        }`}
      >
        Composição do custo
      </p>

      <div
        className={`mt-3 flex h-3 w-full overflow-hidden rounded-full ${
          onPrimary ? "bg-primary-foreground/20" : "bg-muted"
        }`}
        role="img"
        aria-label={`Combustível ${fuelPct.toFixed(0)}%, pedágio ${tollPct.toFixed(0)}%`}
      >
        <div className={onPrimary ? "bg-primary-foreground" : "bg-primary"} style={{ width: `${fuelPct}%` }} />
        <div className="bg-accent" style={{ width: `${tollPct}%` }} />
      </div>

      <ul className="mt-3 space-y-2">
        {rows.map((r) => (
          <li key={r.label} className="flex items-center gap-2 text-xs">
            <span className={`size-2.5 shrink-0 rounded-full ${r.className}`} aria-hidden="true" />
            <span className={onPrimary ? "flex-1 opacity-90" : "flex-1 text-muted-foreground"}>{r.label}</span>
            <span className={onPrimary ? "font-semibold" : "font-semibold text-foreground"}>
              {formatBrl(r.value)}
            </span>
            <span
              className={`w-10 text-right tabular-nums ${onPrimary ? "opacity-80" : "text-muted-foreground"}`}
            >
              {r.pct.toFixed(0)}%
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
